import { render, staticRenderFns } from "./dialog-snackbarcleartrash.vue?vue&type=template&id=618b20f2&"
import script from "./dialog-snackbarcleartrash.vue?vue&type=script&lang=js&"
export * from "./dialog-snackbarcleartrash.vue?vue&type=script&lang=js&"
import style0 from "./dialog-snackbarcleartrash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports